import { confirmable, createConfirmation } from "react-confirm";

const MyDialog = ({ show, proceed, message }) => (
  <div
    className={`fixed inset-0 flex items-center justify-center bg-black/50 ${
      show ? "block" : "hidden"
    }`}
  >
    <div className="bg-white rounded-lg p-6 w-[90%] max-w-sm shadow-lg">
      <p className="text-gray-800 mb-4">{message}</p>
      <div className="flex justify-end gap-3">
        <button
          onClick={() => proceed(true)}
          className="px-4 py-2 rounded bg-red-600 text-white hover:bg-red-700"
        >
          Yes, Delete
        </button>
         <button
          onClick={() => proceed(false)}
          className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
);

export const confirm = createConfirmation(confirmable(MyDialog));
